import { STATES } from '../../../../constants';
import { loadFacebook } from './facebook';

export function ShareMovePreviewConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATES.STEP_SHARE_MOVE_PREVIEW, {
    url: '/preview',
    views: {
      '@': {
        template: '<upd-share-move-preview></upd-share-move-preview>',
      },
    },
    scrollTop: true,
    titleBar: {
      title: 'Send Moving Announcements',
      icon: 'share',
      save: 'Save 1 Hour',
    },
    analytics: {
      page: 'Preview Moving Announcement',
    },
    data: {
      permissions: 'signedIn && haveShare',
    },
    onEnter() {
      loadFacebook();
    },
  });
}
